<template>
    <section>
        <div v-if="currentVersion=== 'teacher'" :class="shit$(`h:64px; dis:f; align-i:c;`)">
            <i :class="['el-icon-caret-bottom', shit$(`c:#979797; ml:6px; mr:3px; font:18px;`)]"></i>
            <svg-icon :href="'#t-code-file-manage-cloud'" :width="20" :height="20"></svg-icon>
            <span :class="shit$(`c:#fff; letter-s:0.93px; font:14px; ml:10px;`)">{{this.$t( "code-lab/component/layout/control-menue/control-menu.vue_0" ) }}</span>
        </div>
        <div v-else :class="shit$(`h:64px; dis:f; align-i:c; bgc:#444; box-shadow: inset 0 0 3px 1px rgba(31, 31, 31, 0.5);`)">
            <img :src="`${ env$ }static/svg/file-manager/cloud.svg`" :class="shit$(`ml:28px;`)"/>
            <span :class="[ shit$(`c:#0ed3ff; letter-s:0.93px; font:13px; ml:10px; font-w:500; `), shit$('mr:5px; ellipsis;') ]">{{this.$t( "code-lab/component/layout/control-menue/control-menu.vue_1" ) }}</span>
        </div>
        <List-t v-if="currentVersion=== 'teacher'" :slotItemStr="'slotItemStr'" @childClick="childClick" :list="listData.data" :look="listData.class">
            <template v-slot:slotItemStr="{ listItemIndex, listItem }">
                <div :class="[shit$(listData.shit.itemWrapper)]">
                    <svg-icon v-if="listItem.svg$" :href="listItem.svg$ + (listItem.active$ ? '-press' : '')" :width="20" :height="20"></svg-icon>
                    <span :class="[ shit$(listData.shit.label) ]">{{ listItem.label }}</span>
                </div>
            </template>
        </List-t>
    </section>
</template>

<script>
import listT from '@/code-lab/view/organization/custom/list-f.vue'
import { store as menueStore, mutations as menueMutations } from './observable.js'
import { mapState } from 'vuex'
export default {
    components: {
        'List-t': listT
    },
    computed: {
        ...mapState({
            currentVersion: 'currentVersion',
            env$: "env$"
        }),
        current () { return menueStore.current },
        listData () {
            return menueStore[this.currentVersion].listData
        }
    },
    created () {
        this.addStyle(this.current)
    },
    methods: {
        childClick (item) {
            this.handleStyle(item)
        },
        handleStyle (item) {
            this.addStyle(item.key)
            menueMutations.current(item.key)
        },
        addStyle (newValue) {
            this.removeStyle()
            const result = this.listData.data.find(fo => fo.key === newValue)
            result.active$ = `c:#0ed3ff; box-shadow: inset 0 0 3px 1px rgba(31, 31, 31, 0.5); bgc:#444; b:0.5px; bc:rgba(31, 31, 31, 0.5);`
        },
        removeStyle () {
            this.listData.data.forEach(fo => fo.active$ = '')
        }
    }
}
</script>
